var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgExperience(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 14,
    viewBox: "0 0 13 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2803_294317)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.55241 3.84356V2.13796C9.55241 1.28516 8.69961 1.28516 8.69961 1.28516H4.47825C4.47825 1.28516 3.53676 1.28686 3.58281 2.13796V3.84356H1.87721C1.87721 3.84356 1.02441 3.84356 1.02441 4.69636V10.666C1.02441 11.5188 1.87721 11.5188 1.87721 11.5188H11.258C11.258 11.5188 12.1108 11.5188 12.1108 10.666V4.69636C12.1108 3.84356 11.258 3.84356 11.258 3.84356H9.55241ZM4.86201 2.56436H8.27321V3.84356H4.86201V2.56436Z",
    fill: "#00A0AE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2803_294317"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.792,
    height: 12.792,
    fill: "white",
    transform: "translate(0.171875 0.433594)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperience);
export default __webpack_public_path__ + "static/media/experience.2364eb7f1d622c7d86cb1b9f749b66ce.svg";
export { ForwardRef as ReactComponent };